(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["article-short-toc"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('youtube-short')) {
    customElements.define(
      'youtube-short',
      class extends HTMLElement {
        connectedCallback() {
          this.querySelector('button')?.addEventListener('click', () => this.play(), { once: true });
        }

        play() {
          const id = this.dataset.videoId;
          if (!/^[\w-]{11}$/.test(id)) return;
          const iframe = document.createElement('iframe');
          iframe.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&playsinline=1&rel=0`;
          iframe.title = this.querySelector('button')?.getAttribute('aria-label') || 'YouTube video';
          iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
          iframe.allowFullscreen = true;
          this.replaceChildren(iframe);
          iframe.focus();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
